import React, { useState, useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import Icon from 'srcReact/components/icons/Icon'

import styles from './styles.module.scss'
import Label from 'srcReact/components/common2/Label'
import RequiredStar from 'srcReact/components/common2/RequiredStar'
import ErrorMessage from '../ErrorMessage'

const PasswordTextBox = ({
  label,
  value,
  isRequired,
  name = 'password',
  direction = 'row',
  placeholder,
  handleChange,
  iconAlt,
  onBlur,
  className,
  containerClassName,
  customLabelCss,
  enableShowPassword = true,
  errorMessage = '',
  setRef,
  ...rest
}) => {
  const [showPassword, setShowPassword] = useState(false)
  const togglePasswordVisibility = (e) => {
    setShowPassword(!showPassword)
  }

  const inputRef = useRef(null)
  useEffect(() => {
    if (setRef) {
      setRef(inputRef)
    }
  }, [])

  return (
    <div className={`${styles.password} ${styles[direction]} ${containerClassName}`}>
      {label && (
        <Label ariaLabel={label} className={customLabelCss}>
          {label}
          {isRequired && <RequiredStar />}
        </Label>
      )}
      <div className={styles.passwordInputWrapper}>
        <input
          ref={inputRef}
          type={showPassword ? 'text' : 'password'}
          placeholder={placeholder}
          className={`${styles.passwordInput} ${className}`}
          name={name}
          value={value}
          onBlur={onBlur}
          onChange={handleChange}
          {...rest}
        />
        {enableShowPassword && (
          <button type='button' className={styles.passwordButtonEye} onClick={togglePasswordVisibility}>
            {!showPassword ? (
              <Icon name='see' size='large24' alt={iconAlt} styleModifier={styles.passwordEyeIcon} />
            ) : (
              <Icon name='unsee' size='large24' alt={iconAlt} styleModifier={styles.passwordEyeIcon} />
            )}
          </button>
        )}
      </div>
      {errorMessage && <ErrorMessage text={errorMessage} className={styles.error} />}
    </div>
  )
}

PasswordTextBox.propTypes = {
  password: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired
}

export default PasswordTextBox
